<template>
  <div class="v2-events v2-container v2-section">
    <header class="v2-events__header">
      <div class="v2-events__title-block">
        <p class="v2-overline">Membresía</p>
        <h1 class="v2-headline v2-headline--display-lg v2-events__title">
          Eventos
        </h1>
        <p class="v2-body v2-body--md v2-body--muted">
          Descubre los próximos eventos, talleres y networking de tu cámara.
        </p>
      </div>
    </header>

    <section class="v2-events__tabs" role="tablist" aria-label="Eventos y mis inscripciones">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        type="button"
        role="tab"
        class="v2-events__tab"
        :class="{ 'v2-events__tab--active': activeTab === tab.value }"
        :aria-selected="activeTab === tab.value"
        @click="setTab(tab.value)"
      >
        <v-icon size="16">{{ tab.icon }}</v-icon>
        <span>{{ tab.label }}</span>
        <span v-if="tab.count > 0" class="v2-events__tab-count">{{ tab.count }}</span>
      </button>
    </section>

    <div v-if="activeTab === 'catalog'" class="v2-events__panel">
      <EventsCatalog />
    </div>
    <div v-else-if="activeTab === 'my'" class="v2-events__panel">
      <MyEnrollments />
    </div>
  </div>
</template>

<script>
import EventsCatalog from "./EventsCatalog.vue";
import MyEnrollments from "./MyEnrollments.vue";

const VALID_TABS = ["catalog", "my"];

export default {
  name: "MemberDashboardV2Events",
  components: { EventsCatalog, MyEnrollments },
  data() {
    return {
      tabs: [
        { value: "catalog", label: "Eventos", icon: "mdi-calendar-multiple", count: 0 },
        { value: "my", label: "Mis inscripciones", icon: "mdi-ticket-account", count: 0 },
      ],
    };
  },
  computed: {
    activeTab() {
      const requested = this.$route && this.$route.query && this.$route.query.tab;
      return VALID_TABS.includes(requested) ? requested : "catalog";
    },
  },
  watch: {
    "$route.query.tab"(value) {
      if (value && !VALID_TABS.includes(value)) {
        this.$router.replace({ query: { ...this.$route.query, tab: "catalog" } });
      }
    },
  },
  methods: {
    setTab(value) {
      if (this.$route.query.tab === value) return;
      this.$router.replace({ query: { ...this.$route.query, tab: value } });
    },
  },
};
</script>

<style scoped>
.v2-events {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.v2-events__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
}

.v2-events__title-block {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
  flex: 1 1 auto;
}

.v2-events__title {
  margin: 0;
}

.v2-events__tabs {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);
  align-self: flex-start;
}

.v2-events__tab {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-2) var(--space-4);
  background: none;
  border: 0;
  font-size: var(--fs-label-sm);
  font-weight: var(--fw-semibold);
  color: var(--color-text-muted);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}

.v2-events__tab:hover {
  color: var(--color-text);
}

.v2-events__tab--active {
  background-color: var(--color-primary);
  color: var(--color-primary-on);
}

.v2-events__tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background-color: var(--color-surface-low);
  color: var(--color-text);
  font-size: 11px;
  font-weight: var(--fw-bold);
  border-radius: var(--radius-full);
}

.v2-events__tab--active .v2-events__tab-count {
  background-color: var(--color-amber);
  color: var(--color-amber-on);
}

.v2-events__panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}
</style>
